var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm.$store.getters.isLoggedIn &&
    _vm.purchase.flags.is_customer &&
    _vm.purchase.actions.customer.supplementary_agreement === "create"
    ? _c(
        "div",
        [
          !_vm.createSupplementaryAgreement
            ? _c(
                "b-dropdown",
                {
                  attrs: {
                    text: "ЗАКЛЮЧИТЬ ДОПОЛНИТЕЛЬНОЕ СОГЛАШЕНИЕ",
                    variant: "custom-green",
                  },
                },
                _vm._l(
                  _vm.$globalDictionaries.fl44SupplementaryAgreementTypes,
                  function (type) {
                    return _c(
                      "b-dropdown-item",
                      {
                        key: type.id,
                        staticClass: "fs-14",
                        on: {
                          click: function ($event) {
                            return _vm.createClicked(type.id)
                          },
                        },
                      },
                      [_vm._v(_vm._s(type.title))]
                    )
                  }
                ),
                1
              )
            : _c(_vm.createComponent, {
                tag: "component",
                attrs: { pivc: _vm.pivc, purchase: _vm.purchase },
                on: {
                  cancel: function ($event) {
                    _vm.createSupplementaryAgreement = false
                  },
                  done: _vm.onSend,
                },
              }),
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }